module.exports = __webpack_public_path__ + "fonts/Muli-Light.c11f1866.ttf";